<template>
  <SupportPageCard
    page-class="faq-detail"
    :title="languages.FAQ || 'FAQ'"
    :show-back="!hideBackBtn"
    @back="back"
  >
    <template #toolbar>
      <faq-notice-bar
        v-if="!loadingPage"
        :source="locationType.faqDetailPage"
      ></faq-notice-bar>
    </template>

    <div class="faq-detail-wrap">
      <van-loading v-if="loadingPage" class="loading" size="48" />
      <template v-else>
        <div class="faq-detail-content">
          <p class="faq-detail-content-title">{{ faqInfo.title }}</p>
          <p class="faq-detail-content-time">
            {{ languages.smartOrderUpdateTime }}：{{ faqInfo.time }}
          </p>
          <div
            class="faq-detail-content-text"
            v-html="faqInfo.content"
            @click="handleATagHref"
          ></div>
        </div>
        <template v-if="showLike">
          <p class="faq-detail-help-tip">{{ languages.smartOrderIsHelp }}</p>
          <div class="faq-detail-like">
            <em
              class="faq-detail-like-btn like icon iconfont icon-like"
              :class="{ active: isLike }"
              @click="handleLike"
            ></em>
          </div>
        </template>
      </template>
    </div>
  </SupportPageCard>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import faqLike from '@mixins/officialSupport/faqLike';
import {
  pageType,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import globalConfig from '@utiles/globalConfig';
import { buildWorkTempQuery } from '@utiles/officialSupport';

const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;

export default {
  name: 'WorkFaqDetail',
  mixins: [faqLike, pointStayTime],
  data() {
    return {
      faqInfo: {
        id: '',
        title: '',
        time: '',
        content: '',
        liked: 0
      },
      loadingPage: false,
      locationType,
      hideBackBtn
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      faqSiteName: state => state.faqSiteName
    }),
    faqId() {
      return this.$route.query.faqId;
    }
  },
  watch: {
    '$route.query.faqId': {
      handler: async function (val, oldVal) {
        if (val && val !== oldVal) {
          window?.officialSupportDataLayer?.push({
            eventName: 'view_page',
            eventType: pageType.faqDetailPage,
            eventValue: { faqId: val }
          });
          this.scrollSsrPageToTop();
          this.initFaqInfo();
          this.showLike && this.updateLikeData();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.scrollSsrPageToTop();
  },
  methods: {
    ...mapActions(['getFaqDetail']),
    /** 进页将 #ssr-page 滚到顶部 */
    scrollSsrPageToTop() {
      this.$nextTick(() => {
        const el = document.getElementById('ssr-page');
        if (el) el.scrollTop = 0;
      });
    },
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workfaqlist');
      } else {
        this.$router.go(-1);
      }
    },
    async initFaqInfo() {
      try {
        this.loadingPage = true;
        const data = await this.getFaqDetail({ id: this.faqId });
        let { ID, TITLE, EDIT_TIME, CONTENT, liked } = data;
        // 若CONTENT中包含形如[[账号找回]](# 'smartTemp-账号找回-10')的内容，将其替换为<a title="smartTemp-账号找回-10">[账号找回]</a>的形式
        const reg = /\[\[(.*?)\]\]\(# 'smartTemp-(.*?)-(\d+)'\)/g;
        CONTENT = CONTENT.replace(reg, (match, p1, p2, p3) => {
          return `<a title="smartTemp-${p2}-${p3}" href="javascript:;">[${p1}]</a>`;
        });
        this.faqInfo.id = ID;
        this.faqInfo.title = TITLE;
        this.faqInfo.time = EDIT_TIME;
        this.faqInfo.content = CONTENT;
        this.faqInfo.liked = liked;
        this.loadingPage = false;
        this.scrollSsrPageToTop();
      } catch (error) {
        console.log(error);
      }
    },
    handleATagHref(event) {
      const target = event.target || event.srcElement;
      if (target.nodeName.toLocaleLowerCase() !== 'a') {
        return;
      }
      const title = target.getAttribute('title') || '';
      if (title && title.includes('smartTemp-')) {
        const id = title?.split('-')?.pop();
        if (id) {
          this.$router.push({
            name: 'worktemp',
            query: buildWorkTempQuery({
              workTempId: id,
              source: locationType.faqDetailPage
            })
          });
        }
      }
    }
  },
  components: {
    SupportPageCard,
    FaqNoticeBar
  }
};
</script>
